<template>
    <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-card>
        <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
              <v-flex xs10>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                  </v-btn>
              </v-flex>
              <!-- <v-flex xs2>
                <report-list-actions
                :reportOptions="reportOptions"
                :downloadFilename="reportListFilename"
                ></report-list-actions>
              </v-flex> -->

              <v-flex xs12>
                <h3 class="text-center mb-5">Missing Clock Out Report</h3>
                <v-divider class="ml-4 mr-4 mb-3"></v-divider>
              </v-flex> 

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendarMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="reportFilters.startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="requiredField"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="reportFilters.startDate"
                    @input="calendarMenu = false"
                    no-title
                    :rules="requiredField"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendar2Menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="reportFilters.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="reportFilters.endDate"
                    @input="calendar2Menu = false"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-btn
                    small
                    class="mt-5"
                    @click="getAllMissedSchedules()"
                >Search</v-btn>
              </v-flex>

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="schedules"
                    sort-by="Date"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Missing Clock Outs"
                    :items-per-page="100"
                  >
                  <template v-slot:item.select="{ item }">
                    
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="viewSchedule(item)"
                      >
                        View
                      </v-btn>
                               
                  </template>
                  </v-data-table>

                  <v-dialog v-model="dialog" max-width="80%">
                    <v-card>
                      <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm  }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            
                            
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn color="blue darken-1" text @click="updateTraining()" v-if="editTraining">Update</v-btn
                        > -->
                        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

              </v-flex>
          </v-layout>
        </v-card>
        <v-dialog v-model="saveScheduleDialog" persistent max-width="75%">
      <v-form
        ref="form"
        lazy-validation
      >
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">Manual Clock Time</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-datetime-picker
                  ref="newClockIn"
                  v-model="ClockIn"
                  time-format="hh:mm a"
                  date-format="yyyy-MM-dd"
                  label="Actual Clock In"
                ></v-datetime-picker>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-datetime-picker
                      ref="newClockOut"
                      v-model="ClockOut"
                      time-format="hh:mm a"
                      date-format="yyyy-MM-dd"
                      label="Scheduled Clock Out"
                    ></v-datetime-picker>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  ref="note"
                  v-model="Note"
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Notes"
                  required
                  :rules="[v => !!v || 'Note is Required']"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="success" @click="addTimesheet()"
          >Update Clock Time</v-btn>
          <v-btn color="blue darken-1" text @click="saveScheduleDialog = false"
          >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {datetime, RRule} from 'rrule';
import ReportFilters from '@/mixins/reportFilters.js';
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    mixins: [
        ReportFilters,
    ],
    components: {
      
    },
    data: () => ({
    headers: [
      {
        text: 'Staff',
        align: 'start',
        sortable: true,
        value: 'user.Name',
      },
      { text: "Date", value: "date" },
      { text: "Actual Clock In", value: "timesheetDetails[0].formattedClockIn" },
      { text: "Scheduled Clock Out", value: "ClockOut" },
      { text: "Program", value: "unitDetails.Name" },
      { text: "Client", value: "clientDetails.Name" },
      { text: "", value: "select" },

    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    employees: [],
    schedules: [],
    ClockIn: null,
    ClockOut: null,
    Note: "",
    selectedSchedule: [],
    saveScheduleDialog: false,
    dialog: false,
    StaffID: '',
    calendarMenu: false,
    calendar2Menu: false,
    menu: false,
    menu2: false,
    report: '',
    staff: '',
    clientName: '',
    isLoading: false,
    titleForm: '',
    role: localStorage.getItem('userRole'),
    state: localStorage.getItem('userState'),
    requiredField: [
        v => !!v || 'This is required',
    ],
    editMissing: false,
    newMissing: false,
    msg: false,
    search: "",
    text: "",
    tempData: [],
    users: [],
    userID: localStorage.getItem("userID"),
    timesheetID: "",
    canDelete: false,
    directCare: false,
    reportListFilename: 'Staff Inventory Report',
    options: {},
    page: 1,
    pageCount: 1,
    itemCount: 0,
    actualClockIn: "",
    reportFilters:  {
        startDate: '',
        endDate: '',
    },
    reportFilterName: 'ReportFilters_ClockOut',
  }),

    computed: {
      
      
    },

    created() {
    //   this.getAllMissedSchedules();
      this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    },

    watch: {
      reportFilters: {
          handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
          },
          deep: true
      }
      
    },

    methods: {
      initialize() {
        this.clocks = [];
      },

      async getEmployees () {
        let endpoint = '';
        const companyIds = localStorage.getItem('userCompanies');

        endpoint = `${url}/users/state/${this.state}`;

        await axios.get(endpoint, {
          params: {
            Company: JSON.parse(companyIds)
          }
        }).then(res => {
          this.users = res.data.users;
          
        });       
      },
      close() {
        this.dialog = false;

      },

      viewSchedule(schedule){
        this.saveScheduleDialog = true;
        this.selectedSchedule = schedule;
        this.Note = schedule.timesheetDetails[0].Note;
        this.ClockIn = moment(schedule.timesheetDetails[0].ClockIn).format("YYYY-MM-DD hh:mm A");
        this.ClockOut = moment(schedule.EndDate).format("YYYY-MM-DD hh:mm A");
        // console.log(schedule);
      },
      
      async getAllMissedSchedules() {
    this.isLoading = true;
    this.schedules = [];

    // Update the route URL to the new endpoint that gets all missed schedules
    await axios.get(`${url}/shifts/getAllMissedSchedulesOut/${this.reportFilters.startDate}/${this.reportFilters.endDate}/${this.state}`)
        .then(response => {
            response.data.schedules.forEach((value) => {
                if (value.isRecurringEvent === "No") {
                    value.ClockIn = moment(new Date(value.StartDate)).format("hh:mm A");
                    value.ClockOut = moment(new Date(value.EndDate)).format("hh:mm A");
                    value.date = moment(new Date(value.StartDate)).format("YYYY-MM-DD");
                    value.Rate = value.user?.Rate || 0;

                    // Format timesheetDetails if it exists
                    if (value.timesheetDetails) {
                        value.timesheetDetails.forEach((timesheet) => {
                            timesheet.formattedClockIn = moment(new Date(timesheet.ClockIn)).format("YYYY-MM-DD hh:mm A");
                            timesheet.formattedClockInSchedule = moment(new Date(timesheet.ClockInSchedule)).format("YYYY-MM-DD hh:mm A");
                            timesheet.formattedClockOutSchedule = moment(new Date(timesheet.ClockOutSchedule)).format("YYYY-MM-DD hh:mm A");
                        });
                    }

                    this.schedules.push(value);
                } else if (value.isRecurringEvent === "Yes") {
                    const recurringYear = moment(value.StartDate).utc().year();
                    const recurringMonth = moment(value.StartDate).utc().format("M");
                    const recurringDay = moment(value.StartDate).utc().format("D");
                    const recurringHour = moment(value.StartDate).utc().format("HH");
                    const recurringMinute = moment(value.StartDate).utc().format("mm");

                    const recurringEndYear = moment(value.EndDate).utc().year();
                    const recurringEndMonth = moment(value.EndDate).utc().format("M");
                    const recurringEndDay = moment(value.EndDate).utc().format("D");
                    const recurringEndHour = moment(value.EndDate).utc().format("HH");
                    const recurringEndMinute = moment(value.EndDate).utc().format("mm");

                    const recurringTypeSwitch = (eventType) => ({
                        "Daily": RRule.DAILY,
                        "Weekly": RRule.WEEKLY,
                        "Monthly": RRule.MONTHLY,
                        "Annually": RRule.YEARLY,
                    })[eventType];

                    const recurringDate = new RRule({
                        freq: recurringTypeSwitch(value.typeOfRecurringEvent),
                        dtstart: datetime(parseInt(recurringYear), parseInt(recurringMonth), parseInt(recurringDay), parseInt(recurringHour), parseInt(recurringMinute)),
                        until: datetime(parseInt(recurringEndYear), parseInt(recurringEndMonth), parseInt(recurringEndDay), parseInt(recurringEndHour), parseInt(recurringEndMinute)),
                        interval: 1
                    });

                    const dateRec = recurringDate.all().map(date =>
                        moment(date).format("YYYY-MM-DD")
                    );

                    dateRec.forEach(itemDate => {
                        let timeStart = moment(value.StartDate).format("hh:mm A");
                        let timeEnd = moment(value.EndDate).format("hh:mm A");
                        let newDate = moment(itemDate).format("YYYY-MM-DD");
                        let newStartDate = new Date(`${newDate} ${timeStart}`);
                        let newEndDate = new Date(`${newDate} ${timeEnd}`);

                        if (moment(newStartDate).format("YYYY-MM-DD") < moment.utc(new Date()).format("YYYY-MM-DD")) {
                            // Check if specific recurring date is already clocked in
                            let result = value.recurringDatesClockIn.some(val => {
                                return moment(val.RecurringDateSchedule).format("YYYY-MM-DD") == newDate;
                            })
                            if (!result) {
                                let newSchedule = {
                                    _id: value._id,
                                    ClientId: value.ClientId,
                                    Company: value.Company,
                                    StartDate: newStartDate,
                                    EndDate: newEndDate,
                                    employee: value.employee,
                                    units: value.units,
                                    user: value.user,
                                    ClockIn: moment(newStartDate).format("hh:mm A"),
                                    ClockOut: moment(newEndDate).format("hh:mm A"),
                                    date: moment(newStartDate).format("YYYY-MM-DD"),
                                    Rate: value.user?.Rate || 0,
                                    isRecurringEvent: value.isRecurringEvent,
                                    typeOfRecurringEvent: value.typeOfRecurringEvent,
                                };

                                // Format timesheetDetails if it exists
                                if (value.timesheetDetails) {
                                    newSchedule.timesheetDetails = value.timesheetDetails.map((timesheet) => ({
                                        ...timesheet,
                                        formattedClockIn: moment(new Date(timesheet.ClockIn)).format("YYYY-MM-DD hh:mm A"),
                                        formattedClockInSchedule: moment(new Date(timesheet.ClockInSchedule)).format("YYYY-MM-DD hh:mm A"),
                                        formattedClockOutSchedule: moment(new Date(timesheet.ClockOutSchedule)).format("YYYY-MM-DD hh:mm A"),
                                    }));
                                }

                                this.schedules.push(newSchedule);
                            }
                        }
                    });
                }
            });
        })
        .finally(() => {
            this.schedules.sort((a, b) => {
                return moment.utc(new Date(b.date)) - moment.utc(new Date(a.date));
            });

            this.isLoading = false;
        });
},


        async addTimesheet(){
        const ClockIn = moment(moment(new Date(this.ClockIn)).format("YYYY-MM-DD hh:mm a")).utc();
        const ClockOut = (this.ClockOut !== "" && this.ClockOut !== null) ?  moment(moment(new Date(this.ClockOut)).format("YYYY-MM-DD hh:mm a")).utc() : "";
        const difference = moment(this.ClockOut).diff(moment(this.ClockIn));

        if (this.$refs.form.validate()) {

          if(difference < 0){
            this.msg = true
            this.text = "Clock Out date must be greater than Clock In date."
          }else if(this.ClockIn !== "Invalid Date" && this.ClockOut !== "" && this.ClockOut != null){

            const { _id, employee, units, ClientId, StartDate, EndDate, Rate } = this.selectedSchedule;
            const req_body = {
              ClockIn: ClockIn,
              ClockOut: ClockOut,
              Note: this.Note,
              ScheduleId: _id,
              EmployeeId: employee,
              ClockInSchedule: StartDate,
              ClockOutSchedule: EndDate,
              ClientId: ClientId,
              Program: units,
              Rate: Rate
            };

            await axios.post(`${url}/timeSheets/manualClock`, req_body ).then(res => {
              if (res.status === 400) {
                res.json().then(function(data) {
                    this.msg = true
                    this.text = data.msg
                });
              }else{
                this.msg = true
                this.text = "The time sheet has been added successfully"

              }
            }).finally(() => {
              this.saveScheduleDialog = false;
              this.getAllMissedSchedules();
              this.Note = "";
            });

          }else{
            this.msg = true
            this.text = "Invalid Dates"
            
          }

        }

      },

    }
  }
</script>
<style>
#print {
  display: none
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}



@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  @media print { 
    #print{ 
    display: block; 
    border: none; 
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

    }
    

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none; 

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  
    
  } 
</style>